import React from 'react';
import Grid from '@mui/material/Unstable_Grid2/Grid2';
import { Box } from '@mui/material';
import ClientCallOutTable from './ClientCallOutTable';
import ClientCallOutDetailsTable from './ClientCallOutDetailsTable';
import ClientCallOutMoeTable from './ClientCallOutMoeTable';

export default function ClientCallOutTab() {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={12} md={6} lg={6}>
        <ClientCallOutDetailsTable />
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={6}>
        <Box>
          <ClientCallOutTable />
        </Box>
        <Box>
          <ClientCallOutMoeTable />
        </Box>
      </Grid>
    </Grid>
  );
}
